@if (data.design === 'card') {
    <div
        class="hippo-confirmation-card"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane">
        <header
            class="hippo-confirmation-card__head"
            cdkDragHandle>
            @if (data.icon?.show) {
                <span
                    class="hippo-confirmation-card__icon"
                    [ngClass]="'is-' + data.icon.color">
                    <mat-icon
                        class="text-current icon-size-5"
                        [svgIcon]="data.icon.name"></mat-icon>
                </span>
            }
            @if (data.title) {
                <h2
                    class="hippo-confirmation-card__title"
                    [innerHTML]="data.title"></h2>
            }
            @if (data.dismissible) {
                <button
                    type="button"
                    class="hippo-confirmation-card__close"
                    [matDialogClose]="undefined">
                    <mat-icon
                        class="text-current icon-size-5"
                        [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
            }
        </header>

        @if (data.message) {
            <div class="hippo-confirmation-card__body">
                <div
                    class="hippo-confirmation-card__message"
                    [innerHTML]="data.message"></div>
            </div>
        }

        @if (data.actions?.confirm?.show || data.actions?.cancel?.show) {
            <footer class="hippo-confirmation-card__actions">
                @if (data.actions.cancel.show) {
                    <button
                        type="button"
                        class="hippo-confirmation-card__btn"
                        [matDialogClose]="'cancelled'">
                        {{ data.actions.cancel.label }}
                    </button>
                }
                @if (data.actions.confirm.show) {
                    <button
                        type="button"
                        class="hippo-confirmation-card__btn"
                        [class.is-danger]="
                            data.actions.confirm.color === 'warn'
                        "
                        [matDialogClose]="'confirmed'">
                        {{ data.actions.confirm.label }}
                    </button>
                }
            </footer>
        }
    </div>
} @else {
    <div
        class="relative flex flex-col w-full h-full bgc_090"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane">
        <!-- Dismiss button -->
        @if (data.dismissible) {
            <div class="absolute top-0 right-0 pt-4 pr-4">
                <button
                    mat-icon-button
                    class="hippo-confirmation__close"
                    [matDialogClose]="undefined">
                    <mat-icon
                        class="text-secondary"
                        [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
            </div>
        }
        <!-- Title -->
        @if (data.title) {
            <div
                cdkDragHandle
                class="hippo-confirmation__title cursor-move"
                [class.hippo-confirmation__title--icon]="iconInTitle">
                @if (iconInTitle) {
                    <span
                        class="hippo-confirmation__title-icon"
                        [ngClass]="iconColor">
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="data.icon.name"></mat-icon>
                    </span>
                }
                <span [innerHTML]="data.title"></span>
            </div>
        }
        <!-- Content -->
        <div
            class="flex flex-auto"
            [ngClass]="
                iconInTitle
                    ? 'hippo-confirmation__body--aligned'
                    : 'flex-col sm:flex-row items-center sm:items-start p-8 pb-6 sm:pb-8'
            ">
            <!-- Icon -->
            @if (data.icon?.show && !iconInTitle) {
                <div
                    class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full"
                    [ngClass]="iconColor">
                    <mat-icon
                        class="text-current"
                        [svgIcon]="data.icon.name"></mat-icon>
                </div>
            }

            @if (data.message) {
                <div
                    class="flex flex-col space-y-1"
                    [ngClass]="
                        iconInTitle
                            ? ''
                            : 'items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 text-center sm:text-left'
                    ">
                    <!-- Message -->
                    @if (data.message) {
                        <div
                            class="text-secondary"
                            [innerHTML]="data.message"></div>
                    }
                </div>
            }
        </div>

        <!-- Actions -->
        @if (data.actions?.confirm?.show || data.actions?.cancel?.show) {
            <div
                class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bgc_090 dark:bg-black dark:bg-opacity-10">
                <!-- Cancel -->
                @if (data.actions.cancel.show) {
                    <button
                        mat-stroked-button
                        [matDialogClose]="'cancelled'">
                        {{ data.actions.cancel.label }}
                    </button>
                }
                <!-- Confirm -->
                @if (data.actions.confirm.show) {
                    <button
                        mat-flat-button
                        [color]="data.actions.confirm.color"
                        [matDialogClose]="'confirmed'">
                        {{ data.actions.confirm.label }}
                    </button>
                }
            </div>
        }
    </div>
}
